if (document.getElementById('reports-link')) {
  document.getElementById('reports-link').addEventListener('click', function (e) {
    e.preventDefault();

    //hanlde scroll position
    const element = document.getElementById('Reports');
    const headerOffset = 100;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });

    document.getElementById('Reports').click();
  });
}
